import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.timeout = 45000;
let csrfToken;
let csrfRead;

function serverUrl(path) {
  return `${process.env.VUE_APP_API_URL}/${path.replace(/^\/+/, '')}`;
}

function fields(value) {
  if (!value || (typeof FormData !== 'undefined' && value instanceof FormData)) return value;
  return Object.keys(value).reduce((result, key) => {
    if (value[key] !== undefined && value[key] !== null && value[key] !== '') result[key] = value[key];
    return result;
  }, {});
}

function csrf() {
  if (csrfToken) return Promise.resolve(csrfToken);
  if (!csrfRead) {
    csrfRead = axios.get(serverUrl('session/csrf'), { timeout: 12000 }).then(response => {
      if (!response.data || !response.data.token) throw new Error('CsrfUnavailable');
      csrfToken = response.data.token;
      return csrfToken;
    }).finally(() => { csrfRead = null; });
  }
  return csrfRead;
}

async function post(path, data, options, retry = true) {
  const token = await csrf();
  try {
    return await axios.post(serverUrl(path), fields(data), {
      ...options, headers: { ...options && options.headers, 'X-CSRF-TOKEN': token },
    });
  } catch (error) {
    // Laravel rejects 419 before the mutation handler. Do not retry timeouts,
    // network failures or arbitrary POST errors, which may have committed.
    if (retry && error.response && error.response.status === 419) {
      csrfToken = null;
      return post(path, data, options, false);
    }
    throw error;
  }
}

export default {
  get(path, params, requestOptions) {
    const query = new URLSearchParams(fields(params) || '').toString();
    return axios.get(`${serverUrl(path)}?${query}`, requestOptions);
  },
  post(path, data, requestOptions) { return post(path, data, requestOptions); },
};
